var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCisem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-4.242 -3.751 116.371 119.168",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 82.365,
    y1: 11.732,
    x2: 72.77,
    y2: 42.081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96561F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B1B1F"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 99.476,
    y1: 37.956,
    x2: 82.416,
    y2: 59.662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5F1216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78091C"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 103.125,
    y1: 67.809,
    x2: 72.425,
    y2: 76.855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#500414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C001E"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 82.579,
    y1: 97.417,
    x2: 66.721,
    y2: 78.293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#400218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F002C"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 55.57,
    y1: 106.14,
    x2: 44.237,
    y2: 79.756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#470021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E003F"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 21.529,
    y1: 96.461,
    x2: 36.457,
    y2: 75.857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#810040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B70040"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 7.014,
    y1: 73.793,
    x2: 22.292,
    y2: 49.826
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#BF005F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C02D26"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 4,
    y1: 43.633,
    x2: 32.207,
    y2: 31.665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C95156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C64F27"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 28.22,
    y1: 11.691,
    x2: 35.226,
    y2: 30.369
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#DA9B22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C03726"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 49.82,
    y1: 5.644,
    x2: 70.171,
    y2: 23.845
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D6A120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C25726"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#a)",
    d: "M86 10.6c9.1 6.6 4.1 29.4-6.4 36.3 1.1-10.2 2.3-27.8-9.9-37.3 5.4.9 11.9-2.2 16.3 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#b)",
    d: "M106.2 38.4c3.5 10.7-14 26.2-26.5 25.6 6.9-7.6 18.2-21.1 13.9-36.1 3.8 4 10.9 5.3 12.6 10.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#c)",
    d: "M106.2 72.8c-3.5 10.7-26.7 12.9-36.5 5.1 10.1-2.1 27.1-6.4 32.4-21 .8 5.4 5.8 10.7 4.1 15.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#d)",
    d: "M86 100.6c-9.1 6.6-29.2-5.2-32.5-17.3 9.4 4.2 25.7 10.8 38.6 2.1-2.6 4.8-1.7 12-6.1 15.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#e)",
    d: "M53.3 111.2c-11.3 0-20.6-21.4-16.1-33.1 5.1 8.9 14.4 23.8 30 24.4-5 2.3-8.4 8.7-13.9 8.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#f)",
    d: "M20.6 100.6C11.5 94 16.5 71.2 27 64.3c-1 10.2-2.3 27.8 10 37.3-5.4-.9-11.9 2.2-16.4-1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#g)",
    d: "M.5 72.8C-3 62 14.5 46.6 26.9 47.2c-6.8 7.6-18.2 21.1-13.9 36C9.2 79.3 2.1 78 .5 72.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#h)",
    d: "M.5 38.4C4 27.7 27.2 25.5 37 33.3c-10.1 2.1-27.1 6.4-32.4 21-.9-5.4-5.8-10.7-4.1-15.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#i)",
    d: "M20.6 10.6c9.1-6.6 29.2 5.2 32.5 17.3-9.4-4.2-25.7-10.8-38.6-2.1 2.7-4.8 1.7-12 6.1-15.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#j)",
    d: "M53.3 0c11.3 0 20.6 21.4 16.2 33.1-5.2-8.9-14.5-23.8-30-24.4C44.4 6.3 47.9 0 53.3 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCisem);
export default __webpack_public_path__ + "static/media/cisem.d6b1043d343b8fd5111419ed042bbd24.svg";
export { ForwardRef as ReactComponent };